// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"c9ca580f","436":"423777b4","525":"b94897ac","723":"99c50e2c"}[chunkId] + ".chunk.js";
};